import React, { useState } from "react";
import Styles from "../../../styles";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { updateMenteeDetails } from "../../../NetworkRequest/requests/mentee";
import { domains, industries } from "../../Constants";
import {useDispatch} from 'react-redux'
import { updateProfileAction } from "../../../reducer/action";

const FirstQuestion = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const state = JSON.parse(localStorage.getItem("userData"));

  const [question, setQuestion] = useState({
    email: state.email,
    phoneNumber: state.phoneNumber || "",
    experience: state.experience || "",
    industry: state.industry || "",
    domain: state.domain || "",
    takeBreak: state.takeBreak || "",
    noOfYears: state.noOfYears || "",
    breakNow: state.breakNow || "",
  });

  const isValidated = () => {
    if (question.phoneNumber.length <= 8) {
      toast.error("Mobile number is not valid");
      return false;
    }

    if (question.domain === "") {
      toast.error("Domain should not be blank");
      return false;
    }
    if (question.experience === "") {
      toast.error("Experience should not be blank");
      return false;
    }

    if (question.industry === "") {
      toast.error("industry should not be blank");
      return false;
    }

    if (question.takeBreak === "") {
      toast.error("Please choose whether you taken career break?");
      return false;
    }
    if (question.takeBreak === "yes") {
      if (question.noOfYears === "") {
        toast.error("Please complete how long was your career break?");
        return false;
      }
      if (question.breakNow === "") {
        toast.error("Are you on a career break?");
        return false;
      }
    }
    return true;
  };

  const handleQuestionSubmit = (e) => {
    const { phoneNumber, experience, industry, domain, takeBreak , noOfYears, breakNow} = question;
    e.preventDefault();
    if (isValidated()) {
      updateMenteeDetails({
        phoneNumber,
        experience,
        industry,
        domain,
        takeBreak,
        noOfYears,
        breakNow,
      })
        .then((res) => {
          if (res.statusCode === 200) {
            dispatch(updateProfileAction());
            history.push("/question");
          } else {
            toast.error("unknow error");
          }
        })
        .catch((e) => console.log(e));
    }
  };

  const handleTextChange = (e) => {
    const q = { ...question };
    q[e.target.name] = e.target.value;
    setQuestion(q);
  };

  const handleExperianceChange = (evt) => {
    setQuestion({ ...question, experience: evt.target.value });
  };

  const handleCareerBreak = (evt) => {
    setQuestion({ ...question, takeBreak: evt.target.value });
  };

  const handleIndustryChange = (evt) => {
    setQuestion({ ...question, industry: evt.target.value });
  };

  const handleDomainChange = (evt) => {
    setQuestion({ ...question, domain: evt.target.value });
  };

  return (
    <div>
      <Styles />
      <div className="wrapper">
        <section className="login-page signup-wrap signup-wrap-3">
          <div className="login-bg">
            <figure className="login-image mb-0">
              <img
                className="img-fluid"
                src="assets/images/login-image.png"
                alt="login image"
                style={{ height: "100vh", objectFit: "cover" }}
              />
            </figure>
          </div>
          <div className="login-form">
            <form onSubmit={handleQuestionSubmit}>
              <div className="form-content mt-5">
                <div className="login-form-content mb-0">
                  <Link to="/">
                    <div className="logo-img-bottom mb-4">
                      <img src="assets/images/logo.png" width={120} height={48} alt="header-logo" />
                    </div>
                  </Link>
                  <div className="sec-title flex-content m-b-md">
                    <h5 className="title mb-0">Quick survey and you are all set!</h5>
                  </div>
                  {/* <div className="sec-content mb-2">
                    <div className="row">
                      <div className="col-12 col-md-9">
                        <p>
                          Please provide your basic details to join us and you are good to go!
                        </p>
                      </div>
                    </div>
                  </div> */}
                  <div className="signup-wrap-content basic-detail m-3 m-b-2 ">
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="form-group">
                          <label>Email ID</label>
                          <input
                            className="form-control"
                            // placeholder="John Doe"
                            type="email"
                            name="email"
                            disabled
                            value={question.email}
                            onChange={handleTextChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-group">
                          <label>
                            Phone Number<sup>*</sup>
                          </label>
                          <input
                            className="form-control"
                            //  placeholder="Yogeshnpl@gmail.com"
                            type="number"
                            name="phoneNumber"
                            value={question.phoneNumber}
                            onChange={handleTextChange}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <div className="form-group select-group">
                          <label htmlFor="exampleFormControl">
                            Domain<sup>*</sup>
                          </label>
                          <select value={question.domain} onChange={handleDomainChange} className="form-control" id="exampleFormControl">
                            <option value="">Select Option</option>
                            {domains.map((domain) => (
                              <option key={`i${domain}`} value={domain}>
                                {domain}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* <div className="col-12 col-md-6">
                        <div className="form-group">
                          <label>Domain</label>
                          <input
                            className="form-control"
                            //  placeholder="Entry value 1"
                            type="text"
                            name="domain"
                            value={question.domain}
                            onChange={handleTextChange}
                          />
                        </div>
                      </div> */}
                      <div className="col-12 col-md-6">
                        <div className="form-group select-group">
                          <label htmlFor="exampleFormControlSelect12">
                            Years of Experience <sup>*</sup>
                          </label>
                          <select
                            onChange={handleExperianceChange}
                            className="form-control"
                            id="exampleFormControlSelect12"
                            name="experience"
                            value={question.experience}
                          >
                            <option value="">Select Option</option>
                            <option value="0">0-8</option>
                              <option value="8">8-12</option>
                              <option value="12">{">12"}</option>
                            {/* <option value="8">8-12</option>
                            <option value="12">{">"}15</option> */}
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <div className="form-group select-group">
                          <label htmlFor="exampleFormControlSelect11">
                            Career Break ?<sup>*</sup>
                          </label>
                          <select
                            onChange={handleCareerBreak}
                            value={question.takeBreak}
                            className="form-control"
                            id="exampleFormControlSelect11"
                          >
                            <option value="">Select Option</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </select>
                        </div>
                      </div>
                      {question.takeBreak === "yes" && (
                        <div className="col-12 col-md-6">
                          <div className="form-group">
                            <label>
                              Number of years<sup>*</sup>
                            </label>
                            <input
                              className="form-control"
                              //  placeholder="Yogeshnpl@gmail.com"
                              type="number"
                              name="noOfYears"
                              value={question.noOfYears}
                              onChange={handleTextChange}
                            />
                          </div>
                        </div>
                      )}

                      {question.takeBreak === "yes" && (
                        <div className="col-12 col-md-6">
                          <div className="form-group select-group">
                            <label htmlFor="exampleFormControlSelect121">Are You On Break Now</label>
                            <select value={question.breakNow} onChange={handleTextChange} className="form-control" id="exampleFormControlSelect121" name="breakNow">
                              <option value="">Select Option</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>
                      )}

                      <div className="col-12 col-md-6">
                        <div className="form-group select-group">
                          <label htmlFor="exampleFormControlSelect1123">
                            Industry<sup>*</sup>
                          </label>
                          <select
                            value={question.industry}
                            onChange={handleIndustryChange}
                            className="form-control"
                            value={question.industry}
                            id="exampleFormControlSelect1123"
                          >
                            <option value="">Select Option</option>
                            {industries.map((industry) => (
                              <option key={`i${industry}`} value={industry}>
                                {industry}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="btn-wrap">
                    <a className="btn btn-gray-color" onClick={() => history.push("/survey")}>
                      <i className="fas fa-arrow-left mr-3" />
                      Previous
                    </a>
                    <button type="submit" className="btn btn-gradient-primary text-white">
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>
    </div>
  );
};
export default FirstQuestion;
